<template>
  <div class="card">
    <div class="card-body p-0">
      <div v-if="loading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="mt-2 text-muted small">Fetching guest notes…</div>
      </div>

      <ul v-else class="list-group">
        <li
          v-for="note in notes"
          :key="note.id || note.email || note.phone"
          class="list-group-item guest-note mb-2"
        >
          <img
            class="avatar"
            :src="note.user_img || 'https://dummyimage.com/100x100/222/fff.png&text=A'"
            alt=""
          />
          <div class="flex-grow-1">
            <p class="name mb-1">{{ note.name || note.username || note.email || 'Guest' }}</p>
            <p class="handle mb-1" v-if="note.username">
              <i class="fas fa-at mr-1"></i>{{ note.username }}
            </p> 
            <p class="note-text mb-0" v-if="note.notes">
              <i class="far fa-sticky-note mr-1"></i>{{ note.notes }}
            </p>
          </div>
        </li>
      </ul>

      <div v-if="!loading && !notes.length" class="text-center p-4">
        <p class="text-muted mb-0">No guest notes yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuestsNotesList',
  props: {
    notes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.guest-note{
  display:flex;
  align-items:flex-start;
  padding:.8rem .75rem;
  border-bottom:1px solid rgba(0,0,0,.06);
}
.guest-note:last-child{ border-bottom:0; }
.avatar{
  width:42px;
  height:42px;
  border-radius:50%;
  object-fit:cover;
  margin-right:.75rem;
  box-shadow:0 1px 5px rgba(0,0,0,.1);
}
.name{ font-weight:600; margin-bottom:0; }
.handle{ color:#888; font-size:.9rem; }
.note-text{ font-size:.95rem; color:#1f2937; }
</style>
